import React, { useEffect, useRef, useState } from 'react'
import Logo from '../Logo/Logo';
import { Link } from 'react-router-dom';
import blueLogo from "../../assets/blueLogo.svg";
import VenueRequestForm from './VenueRequestForm';

import back from "../../assets/back-arrow.svg";
import next from "../../assets/forward-arrow.svg";
import { Helmet } from 'react-helmet-async';

const getVenue= [
  {
    sn: 1,
    name: "Verified Venues Only" ,
    title: "We only recommend venues that have been vetted and reviewed for quality, accessibility, and reliability.",
  },
  {
    sn: 2,
    name: "Saves You Time",
    title:"Skip endless Google searches and calls; we'll do the searching and shortlisting for you.",
  },
  {
    sn: 3,
    name: "Fits Your Budget",
    title: "Get options within or close to your stated budget, with no hidden charges.",
  },
  {
    sn: 4,
    name: " Direct Contact Access",
    title: "We'll connect you directly with venue managers or owners — no middlemen.",
  }
];

const GetVenue = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    eventType: "",
    eventDate: "",
    guestCapacity: "",
    budgetRange: "",
    venueType: "",
    preferredState: "",
    preferredArea: "",
    additionalDetails: "",
    agreeToFee: false,
  });
  const [currentStep, setCurrentStep] = useState(1);
  const [isComplete, setIsComplete] = useState(false);
  const [margins, setMargins] = useState({
    marginLeft: 0,
    marginRight: 0,
  });
  const stepRef = useRef([]);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (stepRef.current.length > 0) {
      setMargins({
        marginLeft: stepRef.current[0]?.offsetWidth / 2 || 0,
        marginRight:
          stepRef.current[stepRef.current.length - 1]?.offsetWidth / 2 || 0,
      });
    }
  }, [stepRef.current]);

  const handleNext = () => {
    setShowForm(true);
  };

  const handleSubmit = () => {
    console.log('Venue request submitted:', formData);
    setSubmitted(true);
  };

  const handlePrevious = () => {
    setShowForm(false);
  };

  return (

    <>
    
    <Helmet>
        <title>Your Ideal Venue, Handpicked for You</title>
        <meta name="description" content="Skip the stress of venue hunting. Pay a small fee and get a curated list of verified venues that perfectly fit your event’s size, budget, and style." />
    </Helmet>
    
     <div className="content">
      <section className="d-flex vendor-registeration">
        <div className="side">
          <div className="logo">
            <Logo />
          </div>

          <h2 className="sub-head"> Why Quickplanners Is the Smart Way to Find a Venue.</h2>

          <div className="register-reason">
            <div>
               {getVenue.map((item) => (
                <div className="reason-item d-flex gap-3" key={item.sn}>
                  <div className="reason-icon">
                    <p className="sn">{item.sn}</p>
                  </div>
                  <div className="reason-items">
                    <p className="">{item.name}</p>
                    <span className="">{item.title}</span>
                  </div>
                </div>
              ))}{" "}
            </div>
          </div>
        </div>

        <div className="main">
          <Link to="/">
            <img src={blueLogo} alt="Logo" className="blue-logo" />
          </Link>

          <h2 className="main-head">Get a Venue</h2>
           <p className="sub-para">
                  Find the Perfect Venue for Your Event — Without the Stress
                </p>
          {submitted ? (
            <div>
              <p className="sub-para">Request submitted successfully!</p>
              <p className="sub-para">Our support team will reach out within 24–48 hours to share curated venue options that fit your request.</p>
            </div>
          ) : (
            <>
            {!showForm ? (
              <>
                <p className="sub-para">
                  Searching for the right venue can be exhausting — comparing prices, checking availability, and hoping it fits your guest list or budget. With Quickplanners, you don’t have to worry. 
                  
                  Simply provide your event details, pay a <strong> ₦10,000 non-refundable fee</strong> , and our team will carefully select venue options that best match your preferences. You’ll also get direct contact details for each venue so you can visit or book with confidence.
                </p>
                
                <p className="sub-para">
                  The ₦10,000 fee covers the time and effort our team spends reviewing your request, researching verified venues, and shortlisting the best options for your event — saving you hours of stress and uncertainty.
                </p>
              </>
            ) : (
              <VenueRequestForm formData={formData} setFormData={setFormData} />
            )}
            </>
          )}
          
          {/* Form details */}

          <div className="">
            <div className="progressbar">
              <div
                style={{
                  width: showForm ? "100%" : "50%",
                }}
              ></div>
            </div>
            <div className="form-container">
             
              <div className="">
                <div className="d-flex justify-content-between align-items-center stepper-nav">
                  {showForm && !submitted && (
                    <button
                      className="step-btn btn-ghost d-flex align-items-center gap-3"
                      onClick={handlePrevious}
                    >
                      <span>
                        <img src={back} alt="previous step arrow" />
                      </span>
                      Back
                    </button>
                  )}
                  <div></div>

                  {submitted && (
                    <Link to="/">
                      <button
                        className={`step-btn btn-full d-flex align-items-center gap-3 complete`}
                      >
                        Done
                      </button>
                    </Link>
                  )}
                  {!isComplete && !submitted && (
                    <>
                      {showForm ? (
                        <button
                          className="step-btn btn-full d-flex align-items-center gap-3 complete"
                          onClick={handleSubmit}
                          disabled={!formData.agreeToFee}
                        >
                          {!loading && "Proceed to Payment"}{" "}
                          {loading && (
                            <div
                              className="spinner-border text-light"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          )}
                        </button>
                      ) : (
                        <button
                          className="step-btn btn-full d-flex align-items-center gap-3"
                          onClick={handleNext}
                        >
                          Next{" "}
                          <span>
                            <img src={next} alt="next step arrow" />
                          </span>
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
   
  );
}

export default GetVenue